import React, { useEffect, useState } from 'react'
// "This library is not maintained." https://github.com/text-mask/text-mask/blob/master/README.md#
import MaskedInput from 'react-text-mask'
import { FormInputError, t } from 'shared'

// FYI: Dob is DateOfBirth

// TODO for Kamil: form, any|s
// TODO for Kamil: Check if comments still relevant
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DobInput = ({ form, locked }: { form: any; locked: boolean }) => {
  // Holds the date as `d.m.y`
  const [rawValue, setRawValue] = useState('')

  // If a value is given, expect it to be a UNIX timestamp and set the
  // internal rawValue state accordingly.
  useEffect(() => {
    let day = form.values.dobDay || form.defaults.dobDay
    let month = form.values.dobMonth || form.defaults.dobMonth
    const year = form.values.dobYear || form.defaults.dobYear

    if (day || month || year) {
      day = day.length === 1 ? `0${day}` : day
      month = month.length === 1 ? `0${month}` : month

      setRawValue([day, month, year].join('.'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Always update the rawValue. Also, if the rawValue looks like a valid date
  // update the form with the UNIX timestamp value (without ms)
  //
  // TODO for Kamil: React.FormEvent<HTMLInputElement> does complain with event.target.value below.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (event: any) => {
    const { updateValues } = form
    const rawValue = event.target.value
    setRawValue(rawValue)

    if (rawValue.match(/^\d{2}.\d{2}.\d{4}$/)) {
      const parts = rawValue.match(/(\d+)/g)
      updateValues({ dobDay: parts[0], dobMonth: parts[1], dobYear: parts[2] })
    } else {
      updateValues({ dobDay: null, dobMonth: null, dobYear: null })
    }
  }

  const error = form.errors.dobDay || form.errors.dobMonth || form.errors.dobYear || form.errors.donorBirthdate
  return (
    <div className={`${error ? 'error' : ''} field`}>
      <label htmlFor="input_dob">{t('attributes.birthdate')}</label>
      <div className={`${locked ? 'disabled right corner labeled' : ''} ui input fluid`}>
        {locked && (
          <div className="ui label label right corner">
            <i aria-hidden="true" className="lock icon"></i>
          </div>
        )}

        <MaskedInput
          id="input_dob"
          className="ui fluid input"
          placeholder={t('misc.date_placeholder')}
          mask={[/[0-3]/, /\d/, '.', /[0-1]/, /\d/, '.', /[1-2]/, /\d/, /\d/, /\d/]}
          onChange={handleChange}
          autoComplete="bday"
          value={rawValue}
          type="tel"
          disabled={locked}
        />
      </div>
      <FormInputError errorSymbol={error} />
    </div>
  )
}
